import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ApplicationBank } from "../../types/applicationBank.type";
import { ResultsScoring } from "../../types/scoring.type";
import { GetSignInfoQueryParams } from "../../api/applicationBankApi/signing.api";

interface IApplicationDataToBankInitial {
  APPLICATION_DATA_TO_BANK: ApplicationBank | null;
  signInfoModal: {
    isOpened: boolean;
    queryParams: GetSignInfoQueryParams | null;
  };
}

const initialState: IApplicationDataToBankInitial = {
  APPLICATION_DATA_TO_BANK: null,
  signInfoModal: {
    isOpened: false,
    queryParams: null,
  },
};

const applicationBankSlice = createSlice({
  name: "APPLICATION_BANK_SLICE",
  initialState,
  reducers: {
    SET_APPLICATION_DATA_TO_BANK: (
      state,
      action: PayloadAction<ApplicationBank>
    ) => {
      state.APPLICATION_DATA_TO_BANK = action.payload;
    },
    SET_SCORING_DATA_TO_BANK: (
      state,
      action: PayloadAction<ResultsScoring>
    ) => {
      if (state.APPLICATION_DATA_TO_BANK) {
        state.APPLICATION_DATA_TO_BANK.scoring_result.data = action.payload;
      }
    },
    CLEAR_APPLICATION_DATA_TO_BANK: (state) => {
      state.APPLICATION_DATA_TO_BANK = null;
    },
    OPEN_SIGN_INFO_MODAL: (
      state,
      action: PayloadAction<GetSignInfoQueryParams>
    ) => {
      state.signInfoModal.isOpened = true;
      state.signInfoModal.queryParams = action.payload;
    },
    CLOSE_SIGN_INFO_MODAL: (state) => {
      state.signInfoModal.isOpened = false;
      state.signInfoModal.queryParams = null;
    },
  },
});

export const {
  SET_APPLICATION_DATA_TO_BANK,
  SET_SCORING_DATA_TO_BANK,
  CLEAR_APPLICATION_DATA_TO_BANK,
  OPEN_SIGN_INFO_MODAL,
  CLOSE_SIGN_INFO_MODAL,
} = applicationBankSlice.actions;

export default applicationBankSlice.reducer;
